import { CommonModule } from "@angular/common";
import {
  ErrorHandler,
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from "@angular/core";
import {
  NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
  NbAuthJWTToken,
  NbAuthModule,
  NbPasswordAuthStrategy,
} from "@nebular/auth";
import { environment } from "environments/environment";

import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthGuard } from "app/@core/auth-guard.service";
import {
  ErrorLogService,
  GlobalErrorHandler,
  HttpErrorInterceptor,
  MiraseeInterceptor,
} from "app/@core/http.interceptor";
import { WINDOW_PROVIDERS } from "app/@core/windowref.provider";
import { throwIfAlreadyLoaded } from "./module-import-guard";

import { ScriptService } from "./utils";

export const NB_CORE_PROVIDERS = [
  ...NbAuthModule.forRoot({
    strategies: [
      NbPasswordAuthStrategy.setup({
        name: "email",
        baseEndpoint: environment.baseUrl,
        login: {
          endpoint: "courses/auth/signin",
          requireValidToken: true,
          redirect: {
            success: "/auth/success",
            failure: null,
          },
          defaultMessages: ["You have been successfully logged in."],
        },
        logout: {
          alwaysFail: false,
          endpoint: "courses/auth/signout",
          requireValidToken: true,
        },
        register: false,
        requestPass: {
          endpoint: "courses/auth/requestpass",
          method: "post",
          redirect: {
            success: "/auth/request-pass",
            failure: null,
          },
          defaultMessages: [
            "Reset password instructions have been sent to your email.",
          ],
        },
        resetPass: {
          endpoint: "courses/auth/resetpass",
          method: "put",
          redirect: {
            success: "/auth/login",
            failure: null,
          },
          resetPasswordTokenKey: "resettoken",
          defaultMessages: ["Your password has been successfully changed."],
        },
        refreshToken: {
          endpoint: "courses/auth/refresh/token",
          method: "post",
          redirect: {
            success: null,
            failure: null,
          },
        },
        token: {
          class: NbAuthJWTToken,
          key: "token",
        },
        errors: {
          key: "msg",
        },
        messages: {
          key: "msg",
        },
      }),
    ],
    forms: {
      requestPassword: {
        redirectDelay: 3000,
      },
      resetPassword: {
        redirectDelay: 2500,
      },
    },
  }).providers,
  AuthGuard,
  WINDOW_PROVIDERS,
  ErrorLogService,
  { provide: ErrorHandler, useClass: GlobalErrorHandler },
  {
    provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
    useValue: function (req: any) {
      return req.url === environment.baseUrl + "courses/auth/refresh/token";
    },
  },
  { provide: HTTP_INTERCEPTORS, useClass: MiraseeInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
  ScriptService,
];

@NgModule({
  imports: [CommonModule],
  exports: [NbAuthModule],
  declarations: [],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, "CoreModule");
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [...NB_CORE_PROVIDERS],
    };
  }
}
